// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/iam.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { RoleSearch } from "./iam";
import type { SearchRolesResponse } from "./iam";
import type { SearchRolesRequest } from "./iam";
import { Roles } from "./iam";
import type { ListRolesResponse } from "./iam";
import type { ListRolesRequest } from "./iam";
import type { UpdateRolesResponse } from "./iam";
import type { UpdateRoleRequest } from "./iam";
import type { GetRolesResponse } from "./iam";
import type { GetRolesRequest } from "./iam";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RoleBindings } from "./iam";
import type { Empty } from "../../../../google/protobuf/empty";
import type { DeleteRoleBindingsRequest } from "./iam";
import type { ListRoleBindingsResponse } from "./iam";
import type { ListRoleBindingsRequest } from "./iam";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RoleBinding } from "./iam";
import type { CreateRoleBindingsRequest } from "./iam";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.iam.v1.RoleBindings
 */
export interface IRoleBindingsClient {
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateRoleBindingsRequest, options?: RpcOptions): UnaryCall<CreateRoleBindingsRequest, RoleBinding>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: ListRoleBindingsRequest, options?: RpcOptions): UnaryCall<ListRoleBindingsRequest, ListRoleBindingsResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteRoleBindingsRequest, options?: RpcOptions): UnaryCall<DeleteRoleBindingsRequest, Empty>;
}
/**
 * @generated from protobuf service c1.api.iam.v1.RoleBindings
 */
export class RoleBindingsClient implements IRoleBindingsClient, ServiceInfo {
    typeName = RoleBindings.typeName;
    methods = RoleBindings.methods;
    options = RoleBindings.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateRoleBindingsRequest, options?: RpcOptions): UnaryCall<CreateRoleBindingsRequest, RoleBinding> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRoleBindingsRequest, RoleBinding>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: ListRoleBindingsRequest, options?: RpcOptions): UnaryCall<ListRoleBindingsRequest, ListRoleBindingsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRoleBindingsRequest, ListRoleBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteRoleBindingsRequest, options?: RpcOptions): UnaryCall<DeleteRoleBindingsRequest, Empty> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRoleBindingsRequest, Empty>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.iam.v1.Roles
 */
export interface IRolesClient {
    /**
     * Get a role by id.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetRolesRequest, options?: RpcOptions): UnaryCall<GetRolesRequest, GetRolesResponse>;
    /**
     * Update a role by passing a Role object.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateRoleRequest, options?: RpcOptions): UnaryCall<UpdateRoleRequest, UpdateRolesResponse>;
    /**
     * List all roles for the current user.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListRolesRequest, options?: RpcOptions): UnaryCall<ListRolesRequest, ListRolesResponse>;
}
/**
 * @generated from protobuf service c1.api.iam.v1.Roles
 */
export class RolesClient implements IRolesClient, ServiceInfo {
    typeName = Roles.typeName;
    methods = Roles.methods;
    options = Roles.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get a role by id.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetRolesRequest, options?: RpcOptions): UnaryCall<GetRolesRequest, GetRolesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRolesRequest, GetRolesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a role by passing a Role object.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateRoleRequest, options?: RpcOptions): UnaryCall<UpdateRoleRequest, UpdateRolesResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRoleRequest, UpdateRolesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all roles for the current user.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListRolesRequest, options?: RpcOptions): UnaryCall<ListRolesRequest, ListRolesResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRolesRequest, ListRolesResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.iam.v1.RoleSearch
 */
export interface IRoleSearchClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchRolesRequest, options?: RpcOptions): UnaryCall<SearchRolesRequest, SearchRolesResponse>;
}
/**
 * @generated from protobuf service c1.api.iam.v1.RoleSearch
 */
export class RoleSearchClient implements IRoleSearchClient, ServiceInfo {
    typeName = RoleSearch.typeName;
    methods = RoleSearch.methods;
    options = RoleSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchRolesRequest, options?: RpcOptions): UnaryCall<SearchRolesRequest, SearchRolesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRolesRequest, SearchRolesResponse>("unary", this._transport, method, opt, input);
    }
}
